export default {
  label: {
    message: 'Exportar como {type}',
  },
};
